import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Sticky.module.scss";
import MobileContext from "../../context/mobile";
import StickyContext from "../../context/sticky";

const Sticky = (props) => {
  const isMobile = useContext(MobileContext);
  let { height, mobileEnable } = props;
  const refContainer = useRef(null);
  const refWrap = useRef(null);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const container = refContainer.current;
    const wrap = refWrap.current;
    const scrollHandler = () => {
      let currentProgress = 0;
      if (wrap.getBoundingClientRect().top < 0 && wrap.getBoundingClientRect().bottom - window.innerHeight > 0) {
        currentProgress = (-wrap.getBoundingClientRect().top / (wrap.offsetHeight - window.innerHeight)) * 100;
      } else if (wrap.getBoundingClientRect().top >= 0) {
        currentProgress = 0;
      } else {
        currentProgress = 100;
      }
      
      setProgress(currentProgress);
    }
    let options = {
      threshold: 0.0,
      rootMargin: '0% 0% 0% 0%'
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          scrollHandler();
          document.addEventListener('scroll', scrollHandler);
        } else {
          document.removeEventListener('scroll', scrollHandler);
          scrollHandler();
        }
      })
    }, options);
    observer.observe(container);

    const setMargins = () => {
      let margin = (container.offsetHeight - container.children[0].offsetHeight) / 2;
      container.style.marginTop = -margin + 'px';
      wrap.style.marginBottom = -margin + 'px';
      if (isMobile && mobileEnable === undefined) {
        container.style.marginTop = '';
        wrap.style.marginBottom = '';
      }
    }
    if(isMobile && mobileEnable !== undefined){
      wrap.classList.add(styles.mobile);
    }else{
      wrap.classList.remove(styles.mobile);
    }

    setMargins();
      window.addEventListener('resize', setMargins);
      window.addEventListener('resize', scrollHandler);
    // if (isMobile && mobileEnable === undefined ) {
    //   setMargins();
    //   window.addEventListener('resize', setMargins);
    //   window.addEventListener('resize', scrollHandler);
    // } else {
    //   setMargins();
    //   observer.unobserve(container);
    //   window.removeEventListener('resize', setMargins);
    //   window.removeEventListener('resize', scrollHandler);
    // }
    
    return () => {
      observer.unobserve(container);
      document.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', setMargins);
      window.removeEventListener('resize', scrollHandler);
    }
  }, [isMobile, mobileEnable]);
  if (isMobile  && mobileEnable === undefined) {
    height = null;
  }
  
  return (
    <>
      <StickyContext.Provider value={progress}>
        <div className={styles.wrap} ref={refWrap} style={{ 'height': height }}>
          <div className={styles.container} ref={refContainer}>
            {props.children}
          </div>
        </div>
      </StickyContext.Provider>
    </>
  );

}

export default Sticky;
